import React from "react";
import {useEffect, useState} from 'react';
import PluginModal from '../pluginModal.js';
import {Button} from '@material-ui/core';
import {api} from '../../utility';
import topic_lodash from 'lodash';
import store from 'store';
import Select from 'react-select';
import * as userActions from '../../actions/authenticationActions';
import {useDispatch} from 'react-redux';
import { useHistory } from "react-router-dom";

function DebugPanel(props){

  const dispatch = useDispatch();
  const history = useHistory();
  const [modalOpen, setModalOpen] = useState(false);

  // envs looks like {"TOPIC_BASE_URL": "dev", "ADTHRIVE_PUBDASH_BASE_URL": "staging", ...}
  let envs = store.get(api.BASE_URL_ENV_LOCALSTORAGE_KEY);
  if(!topic_lodash.isObject(envs)){
    envs = {};
    topic_lodash.each(api.BASE_URL_KEYS, (baseUrlKey) => {
      envs[baseUrlKey] = 'production';
    });
    store.set(api.BASE_URL_ENV_LOCALSTORAGE_KEY, envs);
  }

  const [stateEnvs, setStateEnvs] = useState(envs);

  const handleSelect = (selectedValue) => {
    let newStateEnv = {};
    newStateEnv[selectedValue.baseUrlKey] = selectedValue.value;
    let newEnvs = {...stateEnvs, ...newStateEnv};
    store.set(api.BASE_URL_ENV_LOCALSTORAGE_KEY, newEnvs);
    setStateEnvs(newEnvs);
  }

  const handleClose = () => {
    setModalOpen(false);
    dispatch(userActions.logoutUser());
    history.push('/login_adthrive');
  }

  return(
    <React.Fragment>
      <Button onClick={() => { setModalOpen(true); }}>Debug</Button>
      <PluginModal
        open={modalOpen}
        onClose={handleClose}
      >
        {topic_lodash.map(api.BASE_URL_KEYS, (baseUrlKey) => {
          let availableEnvs = api[baseUrlKey];
          let selectOptions = [];
          topic_lodash.each(availableEnvs, (value, key) => {
            selectOptions.push({
              label: `${key} - ${value}`,
              value: key,
              baseUrlKey: baseUrlKey
            });
          });
          let currentStateEnv = stateEnvs[baseUrlKey]; // should be something like "dev"
          let currentValue = topic_lodash.find(selectOptions, {value: currentStateEnv}); // should be something like {"label": "dev - localhost:3000", "value": "dev"}
          return <div>
            <label htmlFor={baseUrlKey}>{baseUrlKey}</label>
            <Select
              id={baseUrlKey}
              classNamePrefix="select"
              value={currentValue}
              options={selectOptions}
              onChange={handleSelect}
            />
          </div>
        })}
      </PluginModal>
    </React.Fragment>
  );

}

export default DebugPanel;